import { compose, mapProps, withProps } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import BOTSizeSelector from './BOTSizeSelector'
import {
  hasMultipleTireSizes,
  transformTireSizes,
  getStaggeredInformation,
  getMultipleSizesInformation,
  getVehicleName
} from 'components/VehicleConfigurator/components/ConfirmTireSize/helpers'
import { confirmVehicleAndMoveToTiresSearch } from './actions'
import { STAGGERED } from 'components/VehicleConfigurator/components/ConfirmTireSize/constants'
import { getCanonicalUrl, injectDynamicVerbiage } from '../IndexableYMME/helpers'
import { META_DESCRIPTION_MAP, META_TITLE_MAP, SCHEMAS_NAME_MAP } from '../IndexableYMME/constants'
import { withImageSrc } from '../IndexableYMME/hocs'

const withTireSizesMapped = mapProps(({
  tireSizes,
  vehicleMaker,
  vehicleYear: yearDesc,
  vehicleMakerFormmatted: makeDesc,
  vehicleModelFormmatted: modelDesc,
  subModelFormmatted: subModelDesc,
  ...props
}) => {
  const { [STAGGERED]: staggeredTireSizes = [], ...nonStaggeredTireSizes } = transformTireSizes(tireSizes)
  const tireHasMultipleSizes = hasMultipleTireSizes(tireSizes)
  const isStaggered = staggeredTireSizes.length > 0
  return {
    ...props,
    isStaggered,
    tireSizes,
    staggeredTireSizes,
    nonStaggeredTireSizes: Object.keys(nonStaggeredTireSizes).reduce(
      (acc, diameter) => acc.concat(nonStaggeredTireSizes[diameter]), []),
    vehicle: {
      yearDesc,
      makeDesc,
      modelDesc,
      subModelDesc
    },
    vehicleName: getVehicleName({
      makeDesc,
      yearDesc,
      modelDesc,
      subModelDesc
    }),
    instructions: isStaggered ? getStaggeredInformation() :
      tireHasMultipleSizes ? getMultipleSizesInformation(makeDesc) : ''
  }
})

export const withDynamicMetaAndSchemasContent = withProps(({
  '@type': pageType,
  vehicle: {
    makeDesc,
    modelDesc,
    subModelDesc,
    yearDesc
  }
}) => ({
  metaDescription: injectDynamicVerbiage({
    string: META_DESCRIPTION_MAP[pageType],
    vehicleMakerFormmatted: makeDesc,
    vehicleModelFormmatted: modelDesc,
    vehicleYear: yearDesc,
    subModelFormmatted: subModelDesc
  }),
  metaTitle: injectDynamicVerbiage({
    string: META_TITLE_MAP[pageType],
    vehicleMakerFormmatted: makeDesc,
    vehicleModelFormmatted: modelDesc,
    vehicleYear: yearDesc,
    subModelFormmatted: subModelDesc
  }),
  schemasName: injectDynamicVerbiage({
    string: SCHEMAS_NAME_MAP[pageType],
    vehicleMakerFormmatted: makeDesc,
    vehicleModelFormmatted: modelDesc,
    vehicleYear: yearDesc,
    subModelFormmatted: subModelDesc
  })
}))

export const mapStateToProps = ({ app: { data }}) => ({
  canonicalUrl: data ? getCanonicalUrl(data) : ''
})

export default compose(
  withType({ type: 'BOTSizeSelector' }),
  connect(mapStateToProps, { handleTiresSelect: confirmVehicleAndMoveToTiresSearch }),
  withTireSizesMapped,
  withDynamicMetaAndSchemasContent,
  withImageSrc
)(BOTSizeSelector)
